import { createStore } from 'vuex';
import auth from './modules/auth';
import theme from './modules/theme';
import products from './modules/products';
import categories from './modules/categories';
import cart from './modules/cart';
import checkout from './modules/checkout';
import orders from './modules/orders';
import profile from './modules/profile';
import admin from './modules/admin';

export default createStore({
  modules: {
    auth,
    theme,
    products,
    categories,
    cart,
    checkout,
    orders,
    profile,
    admin
  }
});